import { render, staticRenderFns } from "./authority.vue?vue&type=template&id=474e898b&"
import script from "./authority.vue?vue&type=script&lang=js&"
export * from "./authority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports